export const plans = [
  {
    id: "1-week",
    stripe_id: "price_1Qo7RFRqRsZpBbbqrDrFy6bh",
    // stripe_id: "price_1QoSxDRqRsZpBbbqIXDdGEhB",
    duration: "1-WEEK",
    originalPrice: 14.99,
    discountedPrice: 6.99,
    perDay: 0.99,
    popular: false,
  },
  {
    id: "1-month",
    stripe_id: "price_1QniLHRqRsZpBbbqvm4n9AgI",
    duration: "1-MONTH",
    originalPrice: 29.99,
    discountedPrice: 17.99,
    perDay: 0.59,
    popular: false,
  },
  {
    id: "3-months",
    price_id: "price_1QnicWRqRsZpBbbq5HlnxZmF",
    duration: "3-MONTHS",
    originalPrice: 59.99,
    discountedPrice: 29.99,
    perDay: 0.33,
    popular: true,
  },
];
